import { IntegrationSourceEnum } from '@c2b/muven-commons'
import { AuditActorKind } from './AuditInstanceModel'

export interface AuditActorTile {
    // Arquivo em src/channel/images/marks/
    mark?: string
    icon?: string
    text?: string
    // Tokens de tema (src/utils/styles/theme.scss): o tile acompanha claro/escuro
    background: string
    color: string
}

const TILES: Record<AuditActorKind, AuditActorTile> = {
    // Canal sem marca resolvida (fora da lista de canais, ex.: excluído).
    'channel': {text: '?', background: 'var(--surface-3)', color: 'var(--text-muted)'},
    // Ícone genérico de propósito: Bimer, SHOP e InterfaceNet são da mesma
    // fabricante e ficariam com o mesmo logo. O nome do ERP vai no tooltip.
    'backend': {icon: 'server', background: 'var(--surface-tooltip)', color: 'var(--text-on-tooltip)'},
    'muven': {mark: 'muven-cart.png', background: 'var(--brand-fill)', color: 'var(--text-on-brand)'},
    // Mesmo tile do canal personalizado: "um canal", sem marca.
    'generic-channel': {icon: 'store-alt', background: 'var(--tint-brand-bg)', color: 'var(--brand)'},
}

export function getAuditActorTile(kind: AuditActorKind): AuditActorTile {
    return TILES[kind]
}

// Opções do filtro "Modificado por" usam o mesmo tile do ator correspondente.
export function getAuditActorKindBySource(source: IntegrationSourceEnum): AuditActorKind {
    if (source === IntegrationSourceEnum.Backend) {
        return 'backend'
    }

    if (source === IntegrationSourceEnum.Channel) {
        return 'generic-channel'
    }

    return 'muven'
}
